import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /permatitle-noticia/noticia/id/
// Programa radio - /the-last-of-us-candidata-a-ser-una-de-les-millors-series-del-2023/noticia/3205828/
// Programa tv - /coneix-els-72-preseleccionats-de-la-segona-edicio-deuforia/noticia/3205197/
const path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'noticia'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { id } = context.query;

    if (!Number.isInteger(parseInt(id))) {
        return {
            notFound: true
        };
    }

    const options = {
        slugs: path,
        id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
